import { createReducer, on } from '@ngrx/store';
import * as PlantsBySubgroupActions from './plants-by-subgroup.actions';
import { ISelectPlant } from 'src/app/pages/orders/delivery-schedule/components/filters-delivery-schedule/models/filters.model';

export interface PlantsBySubgroupState {
  response: ISelectPlant[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: ISelectPlant[] };
}

export const initialState: PlantsBySubgroupState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const plantsBySubgroupReducer = createReducer(
  initialState,
  on(PlantsBySubgroupActions.loadPlantsBySubgroup, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PlantsBySubgroupActions.loadPlantsBySubgroupSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(PlantsBySubgroupActions.loadPlantsBySubgroupFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(PlantsBySubgroupActions.loadPlantsBySubgroupSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
